(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('DocumentRequirementDetailController', DocumentRequirementDetailController);

  /* ngInject */
  function DocumentRequirementDetailController($state, $stateParams, $window, Flash, config, contractService, documentService, documentRequirementService, sessionService, vendorService, vmsProductService) {
    const vm = this;

    vm.config = config;
    vm.deleteDocument = deleteDocument;
    vm.deleteDocumentRequirement = deleteDocumentRequirement;
    vm.documentRequirement = {};
    vm.id = $stateParams.id;
    vm.resource = {};
    vm.resourceId = $stateParams.resourceId;
    vm.resourceType = $stateParams.resourceType;
    vm.sessionService = sessionService;
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      getDocumentRequirement();
      getResource();
    }

    function deleteDocument() {
      var params = {
        documentRequirementId: vm.id,
        id: vm.documentRequirement.document.id
      };

      if (vm.resourceType == 'vendors') {
        params['resourceType'] = 'vendors';
        params['resourceId'] = vm.resourceId;
        params['vendor_id'] = vm.resourceId;
      }

      if (vm.resourceType == 'contracts') {
        params['resourceType'] = 'contracts';
        params['resourceId'] = vm.resourceId;
        params['contract_id'] = vm.resourceId;
      }

      documentService(sessionService.getAuthToken()).destroy(params,
        _ => {
          $state.reload();
          Flash.create('success', 'Document successfully deleted.');
          angular.element('#deleteDocumentModal').modal('hide');
        }, _ => {
          angular.element('#deleteDocumentModal').modal('hide');
          Flash.create('danger', 'An unexpected error occurred. Please try again later.');
        });
    }

    function deleteDocumentRequirement() {
      var params = { id: vm.id };
      params.resourceType = vm.resourceType;
      params.resourceId = vm.resourceId;

      documentRequirementService(sessionService.getAuthToken()).destroy(params,
        _ => {
          if (vm.resourceType == 'products') {
            $state.go('application.vms.product-detail', { vendorId: vm.vendorId, id: vm.resourceId });
          } else {
            $state.go(`application.vms.${vm.resourceType}`);
          }

          Flash.create('success', 'Document requirement successfully deleted.');
          angular.element('#deleteDocumentRequirementModal').modal('hide');
        }, _ => {
          angular.element('#deleteDocumentRequirementModal').modal('hide');
          Flash.create('danger', 'An unexpected error occurred. Please try again later.');
        });
    }

    function getDocumentRequirement() {
      documentRequirementService(sessionService.getAuthToken()).get({ resourceType: vm.resourceType, resourceId: vm.resourceId, id: vm.id }, response => vm.documentRequirement = response);
    }

    function getResource() {
      if (vm.resourceType == 'vendors') {
        vendorService(sessionService.getAuthToken()).get({ id: vm.resourceId }, response => vm.resource = response);
      } else if (vm.resourceType == 'contracts') {
        contractService(sessionService.getAuthToken()).get({ id: vm.resourceId }, response => vm.resource = response);
      } else if (vm.resourceType == 'products') {
        vmsProductService(sessionService.getAuthToken()).get({ vendorId: vm.vendorId, id: vm.resourceId }, response => vm.resource = response);
      } else if (vm.resourceType == 'assessments') {
        vendorService(sessionService.getAuthToken()).get({ id: vm.resourceId }, response => vm.resource = response);
      }
    }
  }
})();
